import Vue from "vue";
import Vuex from "vuex";

import users from "./modules/users";
import properties from "./modules/properties";
import peoples from "./modules/peoples";
import cities from "./modules/cities";
import states from "./modules/states";
import orders from "./modules/orders";
import config from "./modules/config";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    users,
    properties,
    peoples,
    cities,
    states,
    orders,
    config,
  },
});
